import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const StatTile: FC = () => (
  <div className="border rounded-lg p-4 flex flex-col gap-2">
    <SkeletonLoader.Text className="h-3 w-20" />
    <SkeletonLoader className="h-8 w-24 rounded" />
    <SkeletonLoader.Text className="h-3 w-16" />
  </div>
);

const DonutTile: FC = () => (
  <div className="border rounded-lg p-4 flex flex-col gap-4 items-center">
    <SkeletonLoader.Text className="h-4 w-32 self-start" />
    <SkeletonLoader.Circle className="h-32 w-32" />
    <div className="w-full space-y-1.5">
      <SkeletonLoader.Text className="h-3 w-full" />
      <SkeletonLoader.Text className="h-3 w-4/5" />
      <SkeletonLoader.Text className="h-3 w-3/5" />
    </div>
  </div>
);

const DashboardPageSkeleton: FC = () => (
  <div className="mx-auto max-w-screen-2xl space-y-6 px-4 py-6 md:px-8">
    <div className="space-y-2">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <SkeletonLoader className="h-8 w-80 rounded" />
        <SkeletonLoader className="h-8 w-36 rounded-lg" />
      </div>
      <div className="flex items-center gap-2">
        <SkeletonLoader.Text className="h-4 w-24" />
        <SkeletonLoader className="h-8 w-48 rounded-lg" />
      </div>
    </div>

    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      <StatTile />
      <StatTile />
      <StatTile />
      <StatTile />
    </div>

    <SkeletonLoader className="h-40 w-full rounded-lg" />

    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <DonutTile />
      <DonutTile />
      <DonutTile />
    </div>

    <SkeletonLoader className="h-6 w-24 rounded" />

    <SkeletonLoader className="h-64 w-full rounded-lg" />
    <SkeletonLoader className="h-64 w-full rounded-lg" />
  </div>
);

export default DashboardPageSkeleton;
